<template>
    <div class="com-item techShow-module" :class="{ active: isactive == true }" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" :style="{
                backgroundColor: W.bgColor || 'transparent',
                color: W.textColor || '#333'
            }">

                <div class="techShow-module__title">
                    <div>
                        <div class="techShow-module__head" v-if="W.enTitle">
                            <p class="techShow-module__en">{{ W.enTitle }}</p>
                        </div>
                        <div class="techShow-module__sub" v-html="W.cnTitleHtml"></div>
                    </div>
                    <a v-if="W.ctaText" class="techShow-module__cta"
                        :href="W.ctaLink && W.ctaLink.linkUrl ? W.ctaLink.linkUrl : 'javascript:void(0)'" target="_self"
                        @click.stop="onCtaClick($event)">
                        <span>{{ W.ctaText }}</span>
                    </a>
                </div>

                <div class="techShow-module__inner">
                    <div class="techShow-module__left">


                        <div class="techShow-module__cards" v-if="W.items && W.items.length">
                            <div class="techShow-module__card" v-for="(item, idx) in W.items" :key="idx">
                                <div class="techShow-module__card-icon">
                                    <img v-if="item.iconUrl" :src="item.iconUrl" />
                                </div>
                                <p class="techShow-module__card-title">{{ item.title }}</p>
                                <p class="techShow-module__card-desc">{{ item.desc }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="techShow-module__right" v-if="W.rightImg">
                        <img :src="W.rightImg" class="techShow-module__img" alt="">
                        <!-- <div class="techShow-module__img" :style="{ backgroundImage: imgRightStyle }"></div> -->
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "techShow-module",
    components: {},
    props: {
        index: { type: Number },
        type: { type: String, default: 'preview' },
        isactive: { type: Boolean, default: false },
        phoneWidth: { type: Number, default: 1280 },
        proportion: { type: Number, default: 1 },
        modata: {
            type: Object,
            default: function () {
                return {
                    WName: 'techShow',
                    Title: '技术实力',
                    MID: 23,
                    ModuleName: 'techShowModule',
                    WContent: {}
                }
            }
        }
    },
    computed: {
        W: {
            get() { return this.modata.WContent || {} },
            set(val) { this.modata.WContent = val }
        },
        imgRightStyle: function () {
            const url = (this.modata.WContent && this.modata.WContent.rightImg) || ''
            const escaped = String(url).replace(/"/g, '\\"')
            return 'url("' + escaped + '")'
        }
    },
    data() { return {} },
    mounted() {
        if (!this.modata.WContent) {
            this.$set(this.modata, 'WContent', {})
        }
    },
    methods: {
        onCtaClick(e) {
            const W = this.modata.WContent || {}
            if (!W.ctaLink || !W.ctaLink.linkUrl) {
                e.preventDefault()
                return
            }
            e.preventDefault()
            this.pageNavigate(W.ctaLink.linkUrl)
        },
        pageNavigate(path) {
            if (!path) return
            if (/^(https?:|mailto:|tel:)/.test(path)) {
                window.open(path)
            } else if (this.$router) {
                this.$router.push(path)
            } else {
                window.location.href = path
            }
        }
    },
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.techShow-module {
      background: linear-gradient(to right, #fff, #f8f8f8);
    margin-bottom: 30px;
    .van-sticky {
        padding: 2% 3%;
        max-width: 1600px;
        margin: 0 auto;
    }

    .techShow-module__title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
         padding: 0 10px;
    }

    .techShow-module__head {
        margin-bottom: 8px;
    }

    .techShow-module__en {
        font-size: 28px;
        font-weight: bold;
        color: #333;
        line-height: 1.4;
        margin: 0;
    }

    .techShow-module__cta {
        color: #e60012;
        font-size: 15px;
    }


    .techShow-module__inner {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;


        position: relative;
    }

    .techShow-module__left {
        flex: 1;
        min-width: 0;
        padding-right: 5%;
        box-sizing: border-box;
    }

    .techShow-module__right {
        flex: 0 0 35%;
         max-width: 430px;
        box-sizing: border-box;
    }



    .techShow-module__sub {
        font-size: 18px;
        line-height: 1.5;
        margin: 0 0 32px;
         color: #e60012;

        ::v-deep p {
            margin: 0 0 6px;
        }

    }

    .techShow-module__cards {

        display: flex;
        flex-flow: row wrap;
        max-width: 800px;
    }

    .techShow-module__card {
        background: #fff;
        border-radius: 10px;
        padding: 24px 20px;
        text-align: center;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
        transition: all 0.3s;
        width: 150px;
        margin-right: 20px;

        &:hover {
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
            transform: translateY(-2px);
        }
    }
     .techShow-module__card:nth-child(2n){
          background: #f5f3f3;
     }

    .techShow-module__card-icon {
        width: 80px;
        height: 80px;
        margin: 0 auto 16px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            max-width: 80%;
            max-height: 80%;
        }
    }

    .techShow-module__card-title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        line-height: 1.4;
        margin: 0 0 8px;
    }

    .techShow-module__card-desc {
        font-size: 13px;
        color: #999;
        line-height: 1.6;
        margin: 0;
        white-space: pre-wrap;
    }

    .techShow-module__img {
        width: 100%;
        height: auto;
        // height: 420px;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
    }


}

@media screen and (max-width: 768px) {
    .techShow-module {
        .techShow-module__inner {
            flex-direction: column-reverse;
        }

        .techShow-module__left {
            padding-right: 0;
            margin-bottom: 0;
            width: 100%;
        }

        .techShow-module__right {
            flex: 0 0 100%;
            max-width: 100%;
            padding-left: 0;
        }

        .techShow-module__img {
            height: 280px;
        }

        .techShow-module__cta {
            position: relative;
            display: table;
            margin: 5px 0 0;
            font-size: 16px;
        }

    .techShow-module__card {
        padding: 20px 5px;
        transition: all 0.3s;
        width: 24%;
        margin:0 1.3% 0 0;
      }
       .techShow-module__card:last-child{
         margin-right: 0;
       }
       .techShow-module__card-title{
        margin-bottom: 3px;
       }
    }
}
</style>